module.exports = __webpack_public_path__ + "static/img/acc_img.0c9ef3ef.png";